import { noAuthInstance } from './axios/index';

const authService = {
  // 유저 인증 (access-token 발급)
  authUser: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/auth/v1/users`,
      // 인증값이 URL 로그에 남지 않도록 기존 키 그대로 JSON 본문으로 전송한다.
      data: params,
      useToast: false,
    };
    return noAuthInstance(requestOptions);
  },
  // 사용자 토큰 갱신
  refreshAuthUser: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/auth/v1/refresh`,
      data: params,
      useToast: false,
    };
    return noAuthInstance(requestOptions);
  },
  // CSV-02: 작업 호텔 전환. 갱신과 같은 입력(user-token·device-token)에 scope-type·hotel-id를 더해
  // 새 토큰을 받습니다(응답 형식은 갱신과 같음). DB에는 쓰지 않습니다.
  switchHotelScope: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/auth/v1/scope`,
      data: params,
    };
    return noAuthInstance(requestOptions);
  },
  authDevice: (params) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'content-type': 'application/json; charset=utf-8' },
      url: `/api/auth/v1/devices`,
      data: params,
    };
    return noAuthInstance(requestOptions);
  },
  addDevice: (data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/devices/v1`,
      data,
    };
    return noAuthInstance(requestOptions);
  },
  updateDevice: (data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/devices/v1`,
      data,
    };
    return noAuthInstance(requestOptions);
  },
  authIdCheck: (authId) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/check/${authId}`,
    };
    return noAuthInstance(requestOptions);
  },
  authPhoneNumber: (phoneNumber) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/auth/phone-number/${phoneNumber}`,
    };
    return noAuthInstance(requestOptions);
  },
  authPhoneNumberCheck: (phoneNumber, authNumber) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/auth/phone-number/${phoneNumber}/auth-number/${authNumber}`,
    };
    return noAuthInstance(requestOptions);
  },
  joinHotelManage: (data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/join/hotel-manage`,
      data,
    };
    return noAuthInstance(requestOptions);
  },
  joinHotelOperator: (data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/join/hotel-operator`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: JSON.stringify(data),
    };
    return noAuthInstance(requestOptions);
  },
  findId: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/find-id/confirm`,
      data: params,
    };
    return noAuthInstance(requestOptions);
  },
  findPassword: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/find-pw/confirm`,
      data: params,
    };
    return noAuthInstance(requestOptions);
  },
  newPassword: (params, verificationToken) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/user/v1/new-pw`,
      data: params,
      // SMS 인증 토큰은 URL·프록시 접근 로그에 남지 않도록 전용 헤더로 전달합니다.
      headers: {
        'verification-token': verificationToken,
      },
    };
    return noAuthInstance(requestOptions);
  },
};

export default authService;
